<template>
  <div id="data-list-list-view" class="data-list-container">
    <location-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :projectId="selectedProjectId"
      @onLocationUpdated="locationUpdated"
      @onLocationInserted="locationInserted"
    />
    <vx-card ref="listCard" :title="$t('GradeControl.Location.Title')" title-color="black" refresh-content-action @refresh="refreshLocationList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="locations"
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="locations.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th sort-key="code">{{$t('GradeControl.Location.Code')}}</vs-th>
          <vs-th sort-key="isActive">{{$t('GradeControl.Location.IsActive')}}</vs-th>
          <vs-th sort-key="type">{{$t('GradeControl.Location.Type')}}</vs-th>
          <vs-th sort-key="density" v-if="useBucketInput">{{ $systemUnits.getDensityLabel()}}</vs-th>
          <vs-th>{{ $systemUnits.getCappingLabel('Gold') }}</vs-th>
          <vs-th>{{ $systemUnits.getCappingLabel('Silver') }}</vs-th>
          <vs-th>{{$t('GradeControl.Location.Capping') + " " + $t('Copper')}}</vs-th>
          <vs-th>{{$t('GradeControl.Location.Capping') + " " + $t('Zinc')}}</vs-th>
          <vs-th>{{$t('GradeControl.Location.Capping') + " " + $t('Lead')}}</vs-th>
          <vs-th>{{$t('GradeControl.Location.AlternateCodes')}}</vs-th>
          <vs-th>{{$t('Action')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="250px;">
                <p class="font-medium truncate">{{ tr.code }}</p>
              </vs-td>
              <vs-td width="75px;">
                <vs-checkbox v-model="tr.isActive" class="mb-2" :disabled="true" ></vs-checkbox>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ getLocationType(tr.type) }}</p>
              </vs-td>
               <vs-td v-if="useBucketInput">
                <p class="font-medium truncate">{{ $systemUnits.convertDensityRounded(tr.density) }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ $systemUnits.convertGradeRounded(getCapping(tr, ElementEnum.Gold)) }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ $systemUnits.convertGradeRounded(getCapping(tr, ElementEnum.Silver)) }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ getCapping(tr, ElementEnum.Copper) }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ getCapping(tr, ElementEnum.Zinc) }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ getCapping(tr, ElementEnum.Lead) }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.alternateCodes }}</p>
              </vs-td>
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.locationId, tr.code)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import locationSideView from "./components/locationSideView";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import { Pager } from "../../../../shared/components";
import LocationTypeEnum from "../../LocationTypeEnum.js";
import ElementEnum from "@/app/shared/ElementEnum.js"

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager,
    locationSideView,
    LocationTypeEnum
  },
  data() {
    return {
      selected: [],    
      selectedProjectId: null,
      ElementEnum,
      itemsPerPage: 20,
      isMounted: false,
      locationTypes: LocationTypeEnum.definition,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    locations() {
      return this.$store.state.gradeControl.locations;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.locations.length;
    },
    useBucketInput() {
      return this.$store.getters.isProjectUsingBucketInput;
    }
  },
  methods: {
    getLocationType(type) {
      return LocationTypeEnum.getNameFor(type);
    },
    getCapping(location, element) {
      const elementCapping = location.cappings.find(c => c.element === element)
      if (elementCapping)
        return elementCapping.capping;

      return "";
    },
    refreshLocationList() {
      this.$store.dispatch("gradeControl/fetchLocationListItems", this.selectedProjectId).then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('GradeControl.Location.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("gradeControl/removeLocation", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("GradeControl.Location.LocationDeleted")
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    locationUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

    },

    locationInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
   
  },
  mounted() {

    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }

    this.isMounted = true;

  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>